import type { IconSvgObject } from './types';

const Speaker01Icon: IconSvgObject = [
  ["path", { d: "M7 22H17C18.6569 22 20 20.6569 20 19V5C20 3.34315 18.6569 2 17 2H7C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "14.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 6H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Speaker01Icon;
